export const smsEagle = "SmsEagle";
export const smsGateway = "SmsGateway";
export const mtnSmsGateway = "MTNSmsGateway";
export const telerivet = "Telerivet";
export const smsGatewayTypes = [smsEagle, telerivet, smsGateway, mtnSmsGateway];
